<template>
  <div class="top">
    <div class="container">
      <a-row :gutter="[20,0]">
        <a-col :xs="0" :xl="16">
          <a-skeleton :loading="request.data.list.length===0" active>
            <router-link :to="`${$Enum.RouterEnum.NewsDetail}?id=${request.data.list[0].article_id}`"
                         class="card card_big">
              <i :style="{backgroundImage:`url('${request.data.list[0].article_cover_address}')`}" />
              <a-typography-title :level="5">
                {{ request.data.list[0].article_title }}
              </a-typography-title>
            </router-link>
          </a-skeleton>
        </a-col>
        <a-col :xs="24" :xl="8">
          <a-skeleton :loading="request.data.list.length===0" active>
            <a-row :gutter="[20,$Store.Public().isGridMatch('>=',$Enum.GridEnum.MD)?20:0]">
              <a-col v-for="(item, index) in request.data.list"
                     :xs="24" :md="8" :xl="index===0?0:24">
                <router-link :to="`${$Enum.RouterEnum.NewsDetail}?id=${item.article_id}`"
                             class="card">
                  <i :style="{backgroundImage:`url('${item.article_cover_address}')`}" />
                  <a-typography-title :level="5">
                    {{ item.article_title }}
                  </a-typography-title>
                </router-link>
              </a-col>
            </a-row>
          </a-skeleton>
        </a-col>
      </a-row>
    </div>
  </div>
</template>

<script lang="ts" type="text/tsx">
import { DataInterface } from '@interface/public';
import {
  NewsInterface,
  RequestGetNewsTop, ResponseGetNewsTop, AxiosGetNewsTop
} from '@server/apiNews';

export default {
  name: 'newsTop',
  data(): DataInterface {
    return {
      request: {
        intercept: {
          list: false
        },
        data: {
          list: [] as NewsInterface[]
        }
      }
    };
  },
  mounted(): void {
    this.getList();
  },
  methods: {
    /**
     * 获取列表
     */
    getList(): void {
      if (this.request.intercept.list) return;
      this.request.intercept.list = true;
      
      AxiosGetNewsTop({} as RequestGetNewsTop)
        .then((res: any) => {
          const data: ResponseGetNewsTop = res.data;
          
          this.request.intercept.list = false;
          if (data.code !== $Enum.CodeEnum.Normal) return;
          
          this.request.data.list = data.data.article_data;
        })
        .catch(() => {
          this.request.intercept.list = false;
        });
    }
  }
};
</script>

<style lang="less" rel="stylesheet/less" scoped>
@import '@resource/css/_global.less';

@image: '@{src_image}page/news/';

.top {
  overflow: hidden;
  position: relative;
  width: 100%;
  padding: @padding*2 @padding @padding;
  background: @color_white;
  
  .container {
    position: relative;
    max-width: @grid_xl;
    width: 100%;
    height: 100%;
    margin: 0 auto;
  }
}

.card {
  display: block;
  overflow: hidden;
  position: relative;
  width: 100%;
  height: 220px;
  .borderBox();
  border-radius: 5px;
  
  &:hover {
    i {
      .transform(translate(-50%, -50%) scale(1.1));
    }
  }
  
  &.card_big {
    height: 460px;
  }
  
  i {
    .center();
    z-index: 0;
    width: 100%;
    height: 100%;
    background-position: center;
    background-size: cover;
    .transition(transform @time);
  }
  
  h5.ant-typography {
    @sh: 50px;
    .position(bottom);
    z-index: 1;
    height: @sh;
    padding: 0 @padding;
    margin: 0;
    background-color: fade(@color_black, 50);
    .font(center, @sh, @color_white, 18px);
    .ellipsis();
  }
}

@media screen and (max-width: -1px+@grid_xl) {
  .card {
    height: 220px !important;
    margin: 0 auto;
  }
}

@media screen and (max-width: -1px+@grid_md) {
  .top {
    padding: @padding;
  }
  
  .card {
    margin: 10px auto !important;
  }
}
</style>